import { render, staticRenderFns } from "./AddUserView.vue?vue&type=template&id=c668c70a&scoped=true&lang=pug&"
import script from "./AddUserView.vue?vue&type=script&lang=js&"
export * from "./AddUserView.vue?vue&type=script&lang=js&"
import style0 from "./AddUserView.vue?vue&type=style&index=0&id=c668c70a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c668c70a",
  null
  
)

export default component.exports